import { render, staticRenderFns } from "./CompareChartNet4.vue?vue&type=template&id=5b3d783a&scoped=true"
import script from "./CompareChartNet4.vue?vue&type=script&lang=js"
export * from "./CompareChartNet4.vue?vue&type=script&lang=js"
import style0 from "./CompareChartNet4.vue?vue&type=style&index=0&id=5b3d783a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3d783a",
  null
  
)

export default component.exports